export default {
      id: "icon-close-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }